import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_wall: FaireCategoryEntity = {
  token: "cat_home-decor-wall",
  type: "category",
  name: "Wall decor",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/wall-decor",
  childCategoryTokens: [
    "cat_wall-all",
    "cat_wall-accents",
    "cat_wall-art",
    "cat_wall-clocks",
    "cat_wall-mirrors",
    "cat_wall-organizers",
    "cat_wallpaper",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
